// src/components/CoreAssure/WeldAssure/WeldAssureResultCard.js
//
// CoreAssure WeldAssure — pass/warn result-display card.
// Mirrors ReadinessScoreCard layout but with binary pass/warn instead of score.

import React from "react";
import { Card, CardContent, Stack, Typography, Box } from "@mui/material";
import { WELD_RESULT_PALETTE, BLOCK_REASON_LABEL } from "../../../utils/coreassure/weldAssureApi";

export default function WeldAssureResultCard({ result }) {
  if (!result || !result.result) return null;

  const palette = WELD_RESULT_PALETTE[result.result] || WELD_RESULT_PALETTE.WARNING;
  const blockerCount = Array.isArray(result.blockers) ? result.blockers.length : 0;
  let blockReasonDisplay = "";
  if (result.blockReason) {
    blockReasonDisplay = BLOCK_REASON_LABEL[result.blockReason] || result.blockReason;
  }

  let computedDisplay = "";
  try {
    computedDisplay = result.computedAt
      ? new Date(result.computedAt).toLocaleString()
      : "";
  } catch (_) { computedDisplay = result.computedAt || ""; }

  return (
    <Card sx={{
      bgcolor: palette.bg,
      border: `2px solid ${palette.border}`,
      height: "100%",
    }}>
      <CardContent>
        <Stack spacing={1} alignItems="center">
          <Typography variant="caption" sx={{ color: palette.fg, letterSpacing: 0.5, fontWeight: 700 }}>
            WELDASSURE RESULT
          </Typography>
          <Box sx={{
            fontSize: 56,
            fontWeight: 800,
            lineHeight: 1,
            color: palette.fg,
          }}>
            {palette.icon}
          </Box>
          <Typography variant="body2" sx={{ color: palette.fg, fontWeight: 600 }}>
            {result.result}
          </Typography>
          {blockReasonDisplay && (
            <Typography variant="caption" sx={{ color: palette.fg, textAlign: "center" }}>
              {blockReasonDisplay}
            </Typography>
          )}
          <Box sx={{ mt: 1, textAlign: "center" }}>
            <Typography variant="caption" color="text.secondary" display="block">
              Weld-task #{result.weldTaskId}
            </Typography>
            {result.welderName && (
              <Typography variant="caption" color="text.secondary" display="block">
                Welder: {result.welderName}
              </Typography>
            )}
            {result.wpsCode && (
              <Typography variant="caption" color="text.secondary" display="block">
                WPS: {result.wpsCode}
              </Typography>
            )}
          </Box>
          {blockerCount > 0 && (
            <Typography variant="caption" sx={{ color: palette.fg }}>
              {blockerCount} blocker{blockerCount === 1 ? "" : "s"} to clear
            </Typography>
          )}
          {computedDisplay && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
              Computed {computedDisplay}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
